import { useEffect, useMemo, useSyncExternalStore, type ReactElement } from 'react';
import { creerClient } from '../../api/client.js';
import type { Ecran } from '../../api/contrat.js';
import { creerControleurClient } from './controleur.js';
import { PaiementClient } from './PaiementClient.js';
import { chargerPrestationsClient, PrestationsClient } from './PrestationsClient.js';
import { chargerPaiementClient } from './source.js';

/** M06 · Régler ma quote-part : l'écran branché dans le registre de la coquille. */
export function EcranPaiement({ ecran }: { ecran: Ecran }): ReactElement {
  const client = useMemo(() => creerClient({ fetch: (...args) => globalThis.fetch(...args) }), []);
  const controleur = useMemo(() => creerControleurClient(() => chargerPaiementClient(client)), [client]);
  const chargerPrestations = useMemo(() => () => chargerPrestationsClient(client), [client]);
  useEffect(() => {
    void controleur.charger();
  }, [controleur]);
  const etat = useSyncExternalStore(controleur.abonner, controleur.etat, controleur.etat);
  return (
    <div data-ecran={ecran.id}>
      <PaiementClient etat={etat} />
      {/* Lignes détaillées (30/10/2026) : la désignation de mes devis et factures, jamais un montant. */}
      <PrestationsClient charger={chargerPrestations} />
    </div>
  );
}
